module.exports = __webpack_public_path__ + "media/images/sage-logo-71c9a42dd8dfff6c71f60c17583207cd.png";